import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=53c54e62&"
import script from "./sticky.vue?vue&type=script&lang=ts&"
export * from "./sticky.vue?vue&type=script&lang=ts&"
import style0 from "./sticky.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports